<script setup>
import { ref, defineProps, defineEmits } from "vue";

const props = defineProps({
  button: { type: String, default: "Create" },
  placeholder: { type: String, required: true },
  id: { type: String, required: true },
});

const emit = defineEmits(["create"]);

const typed = ref("");
const create = () => {
  const text = typed.value.trim();
  if (!text) return;
  emit("create", { text, id: props.id });
  typed.value = "";
};
</script>

<template>
  <form class="flex gap-2" @submit.prevent="create">
    <label :for="`create-${id}`" class="sr-only">{{ placeholder }}</label>
    <input
      :id="`create-${id}`"
      v-model="typed"
      class="field"
      type="text"
      :placeholder="placeholder"
    />
    <button
      type="submit"
      class="btn-primary shrink-0"
      :disabled="!typed.trim()"
    >
      {{ button }}
    </button>
  </form>
</template>
